<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.class}`"
    :data-type="context.type"
  >
    <input
      type="text"
      :class="[small && 'small', context.attributes.class]"
      v-model="context.model"
      v-bind="context.attributes"
      @blur="context.blurHandler"
    />
  </div>
</template>

<script>
export default {
  name: "TTTextInput",
  props: {
    context: Object,
    small: Boolean
  }
};
</script>
